module.exports = __webpack_public_path__ + "static/media/Assets-10-Si-Mayaa-halftone.0886cfc9.png";